import {Context} from '@nuxt/types';
import {initialiseStores} from '~/lib/accessors/store-accessor';


export default function ({ store }: Context) {
  initialiseStores(store);
}
